import React from 'react'
import classnames from 'classnames'
import styles from './style'

const Panel = ({ children, title, className, fullWidth, paddingStyle }) => (
  <section style={{ padding: paddingStyle }} className={classnames('panel', className, { 'full-width': fullWidth })}>
    {title && <div>{title}</div>}
    {children}
    <style jsx>{styles}</style>
  </section>
)

Panel.defaultProps = {
  fullWidth: false,
  paddingStyle: null,
}

export default Panel
